import React from 'react';
import './Table.css';

const Table = ({ headers = [], data = [], onRowClick }) => {
  return (
    <table className="table">
      <thead>
        <tr>
          {headers.map((header, index) => (
            <th key={index}>{header || 'N/A'}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.length > 0 ? (
          data.map((row, rowIndex) => {
            const isInactive = row[2] === '-';
            return (
              <tr 
                key={rowIndex} 
                className={isInactive ? 'inactive-row' : 'regular-row'} 
                onClick={() => onRowClick && onRowClick(row)}
              >
                {row.map((cell, cellIndex) => (
                  <td key={cellIndex}>{cell != null ? cell : 'N/A'}</td>
                ))}
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan={headers.length} style={{ textAlign: 'center' }}>
              No data available
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default Table;
